import * as React from "react";

function TagsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M472.8 168.4c52.3 53 52.3 138.2 0 191.2l-112 113.3c-9.3 9.4-24.5 9.5-33.9.2-9.5-9.3-9.5-24.5-.2-34l111.9-113.2c33.9-34.3 33.9-89.5 0-123.8L310.9 72.87c-9.4-9.43-9.3-24.62.2-33.94 9.4-9.32 24.6-9.23 33 .2L472.8 168.4zM144 143.1c0 18.6-14.3 32-32 32-17.67 0-32-13.4-32-32 0-16.8 14.33-32 32-32 17.7 0 32 15.2 32 32zm266.7 75.6c25 25 25 65.6 0 90.6L277.3 442.7c-25 25-65.6 25-90.6 0l-167.95-168C6.743 262.7 0 246.5 0 229.5V80c0-26.51 21.49-48 48-48h149.5c17 0 33.2 6.74 45.2 18.75l168 167.95zM48 79.1v150.4c0 4.2 1.69 8.3 4.69 11.3l168.01 168c6.2 6.3 16.4 6.3 22.6 0l133.5-133.5c6.3-6.2 6.3-16.4 0-22.6l-168-168.01c-3-3-7.1-5.59-11.3-5.59H48z"
  }));
}

const ForwardRef = React.forwardRef(TagsIcon);
export default ForwardRef;